import React, {useContext, useEffect, useState} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import Button from "../../../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import {v4 as uuidv4} from "uuid";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import useFetchData from "../../hooks/use-fetch-data.js";
import InputTextarea from "../../../../../../components/input/input-textarea.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import GenericEditRemoveCellRenderer
    from "../../../../agents/form/components/tabs/generic-edit-remove-cell-renderer.jsx";
import ConfirmationDeleteList from "../../../../../../components/utils/confirmation-delete-lists.jsx";
import {IndividualContext} from "../../individual-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";

const initialData = () => ({
    itemId: uuidv4(),
    local: "",
    type: "",
    description: "",
});

const OtherCharacteristics = () => {
    const {individual, setIndividual, setChanges} = useContext(IndividualContext)
    const {region, regionDetail} = useFetchData()
    const [openModal, setOpenModal] = useState(false)
    const [data, setData] = useState(initialData)

    const onChange = ({target: {id, value}}) => setData(prev => ({...prev, [id]: value}));
    const onChangeCustom = (value, id) => setData(prev => ({...prev, [id]: value}))

    const remove = (data) => {
        ConfirmationDeleteList(() => {
            setIndividual(prev => ({
                ...prev,
                individualRegionWrapper: prev.individualRegionWrapper.filter(dep => dep.itemId !== data.itemId)
            }));
        })
    }

    const [columnDefs] = useState([
        {headerName: "Local", field: "local", flex: 1, comparator: aggridUtils.nullLastComparator},
        {headerName: "Tipo", field: "type", flex: 1, comparator: aggridUtils.nullLastComparator},
        {headerName: "Descrição", field: "description", flex: 1, comparator: aggridUtils.nullLastComparator},
        {
            headerName: "", field: "", width: 100,
            cellRenderer: GenericEditRemoveCellRenderer,
            cellRendererParams: {setData, setOpen: setOpenModal, remove}
        },
    ]);

    const save = () => {
        let message = ""
        if (!data.description) message = "O campo \"Descrição\" é obrigatório.\n"
        if (!data.local) message = "O campo \"Local\" é obrigatório.\n"
        if (!data.type) message = "O campo \"Tipo\" é obrigatório.\n"

        if (message) {
            projectUtils.swalErrorMessage("", message, "Ok");
            return
        }

        setIndividual(prevItems => {
            const exists = prevItems.individualRegionWrapper.some(t => t.itemId === data.itemId);

            const updated = exists
                ? prevItems.individualRegionWrapper.map(t => (t.itemId === data.itemId ? data : t))
                : [...prevItems.individualRegionWrapper, data];

            return {
                ...prevItems,
                individualRegionWrapper: updated
            }
        });

        setChanges(prev => (prev.includes("characteristics") ? prev : [...prev, "characteristics"]))
        onHide()
    }

    const onHide = () => {
        setData(initialData);
        setOpenModal(false)
    }

    return (
        <>
            <Card className={"mt-2"}>
                <Card.Header className={"gap-2"}>
                    <Card.Title>Outras características</Card.Title>
                    <Button className="h-7.5! w-7.5 p-0!" onClick={() => setOpenModal(true)}>
                        <FaPlus/>
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className={"h-[calc(100vh-305px)]"}>
                        <AgGridReact
                            rowData={individual.individualRegionWrapper}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                        />
                    </div>
                </Card.Body>
            </Card>

            <Modal overflow={true} isCloseClick={false} open={openModal} setOpen={onHide}  title={"Característica"} className={"w-3/12"}>
                <Modal.Body>
                    <SentryRow>
                        <div className="col-span-12">
                            <SelectComponent
                                id={"local"}
                                value={data.local}
                                options={region}
                                label={"Local *"}
                                onChange={(value) => onChangeCustom(value?.value, "local")}
                            />
                        </div>
                        <div className="col-span-12">
                            <SelectComponent
                                id={"type"}
                                value={data.type}
                                options={regionDetail}
                                label={"Tipo *"}
                                onChange={(value) => onChangeCustom(value?.value, "type")}
                            />
                        </div>
                        <div className="col-span-12">
                            <InputTextarea
                                id={"description"}
                                value={data.description}
                                label="Descrição *"
                                textAreaClass={"h-[100px]"}
                                onChange={onChange}
                            />
                        </div>
                    </SentryRow>
                </Modal.Body>

                <Modal.Footer className={"p-1"}>
                    <div className={"w-full flex justify-end"}>
                        <Button onClick={save}>
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default OtherCharacteristics;